import React from 'react';
import { AuthContext } from '../store/AuthContext';
import LoginMeuCorreios from './login/LoginMeuCorreios';

const AbrirNovaSessao = () => {
  const { user, loginUser, perfil, logout, newSession } =
    React.useContext(AuthContext);
  newSession();
  return (
    <>
      <LoginMeuCorreios />
    </>
  );
};
export default AbrirNovaSessao;
